import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const a = r((s, l) => /* @__PURE__ */ c.jsx(
  e,
  {
    ref: l,
    ...s,
    image: (i) => /* @__PURE__ */ c.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...i,
        children: [
          /* @__PURE__ */ c.jsxs("g", { clipPath: "url(#clip0_2974_4148)", children: [
            /* @__PURE__ */ c.jsxs(
              "mask",
              {
                id: "mask0_2974_4148",
                width: 32,
                height: 32,
                x: 8,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: [
                  /* @__PURE__ */ c.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M29.53 28.48c1-1.22 1.6-2.78 1.6-4.48s-.6-3.26-1.6-4.48l5.84-5.83c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-5.85 5.84a7.06 7.06 0 0 0-4.44-1.57c-1.7 0-3.26.6-4.49 1.6l-5.88-5.88a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l5.89 5.88A7.06 7.06 0 0 0 16.91 24c0 1.68.59 3.22 1.56 4.44l-5.89 5.88c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l5.88-5.87c1.22 1 2.79 1.6 4.49 1.6 1.68 0 3.23-.59 4.44-1.57l5.85 5.84c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.77 0-1.06zm.1-4.48c0 1.28-.44 2.47-1.17 3.41L25.04 24l3.42-3.41c.73.94 1.17 2.13 1.17 3.41m-5.61-5.61c1.27 0 2.43.43 3.37 1.14l-3.41 3.41-3.38-3.37c.95-.74 2.13-1.18 3.42-1.18M18.41 24c0-1.26.43-2.43 1.13-3.37L22.92 24l-3.37 3.37A5.6 5.6 0 0 1 18.41 24m5.61 5.61c-1.29 0-2.47-.44-3.42-1.17l3.38-3.37 3.41 3.41c-.94.7-2.1 1.13-3.37 1.13"
                    }
                  ),
                  /* @__PURE__ */ c.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M24 14.74c.41 0 .75-.34.75-.75V8.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v5.24c0 .42.34.75.75.75M24 33.26c-.41 0-.75.34-.75.75v5.24c0 .41.34.75.75.75s.75-.34.75-.75v-5.24c0-.42-.34-.75-.75-.75M14.81 24c0-.41-.34-.75-.75-.75H8.75c-.41 0-.75.34-.75.75s.34.75.75.75h5.31c.42 0 .75-.34.75-.75M39.25 23.25h-5.2c-.41 0-.75.34-.75.75s.34.75.75.75h5.2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ c.jsx("g", { mask: "url(#mask0_2974_4148)", children: /* @__PURE__ */ c.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
          ] }),
          /* @__PURE__ */ c.jsx("defs", { children: /* @__PURE__ */ c.jsx("clipPath", { id: "clip0_2974_4148", children: /* @__PURE__ */ c.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
a.displayName = "AgencySunblockIcon";
export {
  a as AgencySunblockIcon,
  a as default
};
//# sourceMappingURL=index.js.map
